<ng-container>
  <p-toast position="top-left" key="tl"></p-toast>
  <p-toast position="top-center" key="tc"></p-toast>
  <p-toast position="top-right" key="globalToast"></p-toast>
  <p-toast position="bottom-center" key="bc"></p-toast>
</ng-container>
